export default [
	{
		path: '/order/list',
		name: 'OrderList',
		component: () => import('@/views/order/list.vue'),
		meta: { title: '订单列表' }
	},
	{
		path: '/order/detail/:id',
		name: 'OrderDetail',
		component: () => import('@/views/order/detail.vue'),
		meta: { title: '订单详情' }
	},
	{
		path: '/order/invoicing/:id',
		name: 'Invoicing',
		component: () => import('@/views/order/invoicing.vue'),
		meta: { title: '开具发票' }
	},
	{
		path: '/order/invoicing-success/:id',
		name: 'InvoicingSuccess',
		component: () => import('@/views/order/invoicing-success.vue'),
		meta: { title: '提交成功' }
	}
]
